<template>
  <div>
    <section class="analysis" @click="link('hrv')">
      <div class="title">
        <div class="hd" style="color: #FCA251">
          <i class="iconfont icon-xinlv" />
          HRV心脏指数
        </div>
        <div class="bd">
          {{ hrv.time[0] }}
        </div>
      </div>
      <div id="hrv" class="content" />
      <div v-if="!hrv.xData.length" class="empty">暂无数据</div>
    </section>

    <section class="analysis" @click="link('pause')">
      <div class="title">
        <div class="hd" style="color: #FCA251">
          <i class="iconfont icon-shuimian" />
          呼吸暂停次数
        </div>
        <div class="bd">
          {{ pause.time[0] }}
        </div>
      </div>
      <div id="pause" class="content" />
      <div v-if="!pause.xData.length" class="empty">暂无数据</div>
    </section>

    <section class="analysis" @click="link('bp')">
      <div class="title">
        <div class="hd" style="color: #FCA251">
          <i class="iconfont icon-xueya" />
          血压
        </div>
        <div class="bd">
          {{ bp.time[0] }}
        </div>
      </div>
      <div id="bp" class="content" />
      <div v-if="!bp.xData.length" class="empty">暂无数据</div>
    </section>

    <section class="analysis" @click="link('bs')">
      <div class="title">
        <div class="hd" style="color: #30C37F">
          <i class="iconfont icon-xuetang" />
          血糖
        </div>
        <div class="bd">
          {{ bp.time[0] }}
        </div>
      </div>
      <div id="bs" class="content" />
      <div v-if="!bs.xData.length" class="empty">暂无数据</div>
    </section>

    <section class="analysis" @click="link('hb')">
      <div class="title">
        <div class="hd" style="color: #E37FEF">
          <i class="iconfont icon-xinlv" />
          心率
        </div>
        <div class="bd">
          {{ bp.time[0] }}
        </div>
      </div>
      <div id="hb" class="content" />
      <div v-if="!hb.xData.length" class="empty">暂无数据</div>
    </section>

    <section class="analysis" @click="link('bo')">
      <div class="title">
        <div class="hd" style="color: #39AAFF">
          <i class="iconfont icon-xueyang" />
          血氧
        </div>
        <div class="bd">
          {{ bp.time[0] }}
        </div>
      </div>
      <div id="bo" class="content" />
      <div v-if="!bo.xData.length" class="empty">暂无数据</div>
    </section>

    <section class="analysis" @click="link('step')">
      <div class="title">
        <div class="hd" style="color: #FCA251">
          <i class="iconfont icon-paobu" />
          运动
        </div>
        <div class="bd">
          06-18 15:00
        </div>
      </div>
      <div id="step" class="content" />
      <div v-if="!step.xData.length" class="empty">暂无数据</div>
    </section>
  </div>
</template>

<script>
import { fetchHealths } from '@/api/health'
import { dateFormat, dateISO } from '@/utils/tool'

var echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/line')

export default {
  data() {
    return {
      bp: {
        dom: 'bp', // 血压
        color: '#FCA251',
        xData: [],
        Ydata: [],
        YData: [],
        time: []
      },
      bs: {
        dom: 'bs',
        color: '#31C37F',
        xData: [],
        Ydata: [],
        time: []
      },
      hb: {
        dom: 'hb',
        color: '#E37FEF',
        xData: [],
        Ydata: [],
        time: []
      },
      bo: {
        dom: 'bo',
        color: '#39AAFF',
        xData: [],
        Ydata: [],
        time: []
      },
      step: {
        dom: 'step',
        color: '#E37FEF',
        xData: [],
        Ydata: [],
        time: []
      },
      pause: {
        dom: 'pause',
        color: '#E37FEF',
        xData: [],
        Ydata: [],
        time: []
      },
      hrv: {
        dom: 'hrv',
        color: '#E37FEF',
        xData: [],
        Ydata: [],
        time: []
      }
    }
  },
  created() {
    const date = new Date()
    date.setDate(date.getDate() - 10)
    fetchHealths({
      sTime: dateISO(`${dateFormat(date, 'YYYY/MM/DD')} 00:00:01`),
      eTime: dateISO(`${dateFormat(new Date(), 'YYYY/MM/DD')} 23:59:59`),
      order: 0
    }).then(res => {
      const data = res.data.data
      data.breathPauseList.forEach(item => {
        this.pause.xData.push(dateFormat(item.testTime, 'M-D'))
        this.pause.Ydata.push(item.breathpause)
        this.pause.time.push(dateFormat(item.testTime, 'MM-DD hh:mm'))
      })
      this.chart(this.pause)

      data.hRVList.forEach(item => {
        this.hrv.xData.push(dateFormat(item.testTime, 'M-D'))
        this.hrv.Ydata.push(item.hrvIndex)
        this.hrv.time.push(dateFormat(item.testTime, 'MM-DD hh:mm'))
      })
      this.chart(this.hrv)

      data.bloodPressureList.forEach(item => {
        this.bp.xData.push(dateFormat(item.testTime, 'M-D'))
        this.bp.Ydata.push(item.sbp)
        this.bp.YData.push(item.dbp)
        this.bp.time.push(dateFormat(item.testTime, 'MM-DD hh:mm'))
      })
      this.chart(this.bp)

      data.bloodSugarList.forEach(item => {
        this.bs.xData.push(dateFormat(item.testTime, 'M-D'))
        this.bs.Ydata.push(item.bs)
        this.bs.time.push(dateFormat(item.testTime, 'MM-DD hh:mm'))
      })
      this.chart(this.bs)

      data.heartBeatList.forEach(item => {
        this.hb.xData.push(dateFormat(item.testTime, 'M-D'))
        this.hb.Ydata.push(item.hb)
        this.hb.time.push(dateFormat(item.testTime, 'MM-DD hh:mm'))
      })
      this.chart(this.hb)

      data.bloodOxygenList.forEach(item => {
        this.bo.xData.push(dateFormat(item.testTime, 'M-D'))
        this.bo.Ydata.push(item.bo)
        this.bo.time.push(dateFormat(item.testTime, 'MM-DD hh:mm'))
      })
      this.chart(this.bo)

      data.walkStepList.forEach(item => {
        this.bo.xData.push(dateFormat(item.testTime, 'M-D'))
        this.bo.Ydata.push(item.step)
        this.bo.time.push(dateFormat(item.testTime, 'MM-DD hh:mm'))
      })
      this.chart(this.step)
    })
  },
  mounted() {

  },
  methods: {
    chart(data) {
      var myChart = echarts.init(document.getElementById(data.dom))
      const series = [{
        data: data.Ydata,
        type: 'line',
        // smooth: true,
        lineStyle: {
          color: data.color
        },
        itemStyle: {
          color: data.color
        }
      }]
      if (data.dom === 'bp') {
        series.push({
          data: data.YData,
          type: 'line',
          // smooth: true,
          lineStyle: {
            color: '#E37FEF'
          },
          itemStyle: {
            color: '#E37FEF'
          }
        })
      }
      myChart.setOption({
        grid: {
          left: '4%', // 图表距边框的距离
          right: '4%',
          top: '5%',
          bottom: '7%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: data.xData,
          axisLine: {
            lineStyle: {
              color: '#ccc'
            }
          },
          axisLabel: {
            color: '#333'
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          axisLabel: {
            color: '#333'
          }
        },
        series
      })
    },
    link(item) {
      this.$router.push(`/health/${item}`)
    }
  }
}
</script>

<style scoped lang="scss">
  .iconfont {
    background: #FCA251;
    border: 3px solid #FCA251;
    border-radius: 50%;
    color: #fff;
    font-size: 20px;
  }
  .icon-xuetang {
    background: #30C37F;
    border-color: #30C37F;
  }
  .icon-xinlv {
    background: #E37FEF;
    border-color: #E37FEF;
  }
  .icon-xueyang {
    background: #39AAFF;
    border-color:#39AAFF;
  }

  .time {
    background: #fff;
  }
  .analysis {
    background: #fff;
    margin-bottom: 10px;
    border-bottom: 1px solid #ececec;
    position: relative;
    .empty {
      text-align: center;
      color: #999;
      font-size: 12px;
      width: 100%;
      position: absolute;
      top: 45%;
    }
    .title {
      font-size: 14px;
      color: #999;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 15px;
    }
    .bd {
      font-size: 12px;
    }
    .content {
      height: 180px;
      background: #fff;
      border-radius: 5px;
    }
  }
</style>
